import { Link } from '@tanstack/react-router';
import { ChevronRight } from 'lucide-react';

import type { RouteListItem } from '@/types';

import { Button } from '../button';
import { Icon } from '../icon';
import { Text } from '../typography';

export function Breadcrumbs({ pages }: { pages: RouteListItem[] }) {
  return (
    <nav className="mb-1 flex px-px sm:mb-0" aria-label="Breadcrumb">
      <ol className="flex flex-wrap items-center gap-2">
        {pages.map(({ name, path }, i) => (
          <li key={name}>
            <div className="flex items-center">
              {i !== 0 && <Icon icon={ChevronRight} className="text-accent-x-light dark:text-accent-light -ml-1" />}
              {pages.length - 1 === i ? (
                <Text className="text-c-card-muted px-1.5 font-medium italic" aria-current="page">
                  {name}
                </Text>
              ) : (
                <Link to={path}>
                  <Button size="xs" as="link" className="text-c-card-muted px-1.5">
                    {name}
                  </Button>
                </Link>
              )}
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
}
